import assetController from "@/services/assetService";
import deviceTypeController from "@/services/deviceTypeService";
import Swal from "sweetalert2";

export default {
  name: "AssetView",

  data() {
    return {
      loading: false,
      assets: [],
      total: 0,
      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      deviceTypeList: [],
      searchTimeout: null,
      filters: {
        search: "",
        device_type_id: "",
        status: "",
      },
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage) || 1;
    },

    // Hanya tipe Laptop / PC untuk dropdown filter.
    // Kalau tidak ada yang cocok, tampilkan semua tipe.
    laptopPcTypes() {
      const filtered = this.deviceTypeList.filter((dt) =>
        /laptop|pc|computer|notebook/i.test(dt.device_type_name || "")
      );
      return filtered.length ? filtered : this.deviceTypeList;
    },

    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },

  methods: {
    goToAdd() {
      this.$router.push("/asset/asset-it/add");
    },

    goToDetail(id) {
      this.$router.push(`/asset/asset-it/detail/${id}`);
    },

    goToEdit(id) {
      this.$router.push(`/asset/asset-it/edit/${id}`);
    },

    statusLabel(status) {
      const map = { 1: "Active", 0: "Inactive", 2: "Retired" };
      return map[Number(status)] ?? "-";
    },

    statusBadgeClass(status) {
      const map = {
        1: "badge-success",
        0: "badge-danger",
        2: "badge-warning",
      };
      return map[Number(status)] || "badge-secondary";
    },

    async loadMasterData() {
      try {
        const res = await deviceTypeController.getAll({
          limit: 0,
        });

        this.deviceTypeList = res.data || [];
      } catch (error) {
        console.error(error);
      }
    },

    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.getData();
      }, 400);
    },

    applyFilters() {
      this.page = 1;
      this.getData();
    },

    changePerPage() {
      this.page = 1;
      this.getData();
    },

    async getData() {
      try {
        this.loading = true;

        const res = await assetController.getAll({
          page: this.page,
          limit: this.perPage,
          search: this.filters.search || null,
          device_type_id: this.filters.device_type_id || null,
          status: this.filters.status !== "" ? this.filters.status : null,
          sortBy: "asset_id",
          sortDesc: "true",
        });

        console.log("getAll response:", res); // hapus kalau key total sudah ketemu

        this.assets = res.data || [];

        this.total = Number(
          res.total ??
            res.totalData ??
            res.total_data ??
            res.totalRecords ??
            res.pagination?.total ??
            res.meta?.total ??
            0
        );

        // fallback: total tidak ketemu tapi data ada
        if (!this.total && this.assets.length > 0) {
          this.total = this.assets.length;
        }

        if (this.page > this.totalPages) {
          this.page = this.totalPages;
          await this.getData();
        }
      } catch (error) {
        console.error(error);

        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal memuat data asset",
        });
      } finally {
        this.loading = false;
      }
    },

    async deleteData(id) {
      const confirm = await Swal.fire({
        title: "Hapus asset ini?",
        text: "Data yang dihapus tidak dapat dikembalikan",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal",
        confirmButtonColor: "#d33",
      });

      if (!confirm.isConfirmed) return;

      try {
        await assetController.delete(id);

        Swal.fire({
          icon: "success",
          title: "Berhasil dihapus",
        });

        if (this.assets.length === 1 && this.page > 1) {
          this.page--;
        }

        this.getData();
      } catch (error) {
        console.error(error);

        Swal.fire({
          icon: "error",
          title: "Gagal menghapus",
        });
      }
    },

    changePage(p) {
      if (p < 1 || p > this.totalPages) return;

      this.page = p;

      this.getData();
    },
  },

  async mounted() {
    await this.loadMasterData();

    this.getData();
  },

  beforeUnmount() {
    clearTimeout(this.searchTimeout);
  },
};